import styled from '@emotion/styled';
import { ob, confettiFall } from '../../onboardingV2.tokens';

export const ConfettiLayer = styled.div`
    position: fixed;
    inset: 0;
    z-index: 30;
    overflow: hidden;
    pointer-events: none;

    ${ob.reducedMotion} {
        display: none;
    }
`;

export const Piece = styled.span`
    position: absolute;
    display: block;
    opacity: 0;
    animation: ${confettiFall} var(--duration) cubic-bezier(0.2, 0.6, 0.4, 1) var(--delay) 1
        forwards;
`;
